import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/components/theme-provider";
import { THEME_MODE } from "@/constants/theme";
import imageLogoUrl from "/images/fabrion-logo.png";
import imageLogoInvertedUrl from "/images/fabrion-logo-inverted.png";
import imageLogoIconUrl from "/images/fabrion-logo-icon.png";

type LogoProps = {
  expanded: boolean;
};

const Logo: React.FunctionComponent<LogoProps> = ({ expanded }) => {
  const { themeMode } = useTheme();

  return (
    <img
      className={cn("h-8 object-cover object-left -ml-[3px] mr-[3px]", {
        "w-[32px]": !expanded,
      })}
      src={
        expanded
          ? themeMode === THEME_MODE.DARK
            ? imageLogoInvertedUrl
            : imageLogoUrl
          : imageLogoIconUrl
      }
      alt="Fabrion logo"
    />
  );
};

export default Logo;
